import { render, staticRenderFns } from "./baozhuang.vue?vue&type=template&id=48e21e29&scoped=true&"
import script from "./baozhuang.vue?vue&type=script&lang=js&"
export * from "./baozhuang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e21e29",
  null
  
)

export default component.exports